import { render, staticRenderFns } from "./RentConsentTerm.vue?vue&type=template&id=40ba297e&"
import script from "./RentConsentTerm.vue?vue&type=script&lang=js&"
export * from "./RentConsentTerm.vue?vue&type=script&lang=js&"
import style0 from "./RentConsentTerm.vue?vue&type=style&index=0&id=40ba297e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports